export default __webpack_public_path__ + "static/media/icon_calendar_10.f4cf8e3f.svg";